export function PlayIcon() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24">
            <path d="M8 5v14l11-7L8 5z" fill="currentColor" />
        </svg>
    );
}

export function PauseIcon() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24">
            <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" fill="currentColor" />
        </svg>
    );
}

export function LoopOnIcon() {
    return (
        <svg width="24" height="20" viewBox="0 0 24 20">
            <path
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                d="M12.0055 5.25657H7.30241C4.23362 5.25657 1.74609
                7.74431 1.74609 10.8129C1.74609 13.8815 4.23362 16.3692 7.30241 16.3692H16.6976C19.7662 16.3692 22.2539
                13.8815 22.2539 10.8129C22.2539 7.74431 19.7662 5.25657 16.6976 5.25657M12.0055 5.25657L9.37965
                7.88239V2.63062L12.0055 5.25657Z"
            />
        </svg>
    );
}

export function LoopOffIcon() {
    return (
        <svg width="24" height="20" viewBox="0 0 24 20">
            <path
                fill="currentColor"
                d="M10.0868 1.92353L8.37965 0.216309V2.63062V4.25658H7.3024C3.6813 4.25658 0.746094 7.19206 0.746094
                10.8129C0.746094 13.0975 1.91465 15.1093 3.68674 16.283L5.14346 14.8263C3.71608 14.0568 2.74609 12.5481
                2.74609 10.8129C2.74609 8.29657 4.78592 6.25658 7.3024 6.25658H8.37965V7.8824V10.2966L10.0868
                8.5895L12.7126 5.96369L13.4197 5.2566L12.7126 4.54949L10.0868 1.92353ZM8.84316 15.3692H16.6976C19.2139
                15.3692 21.2539 13.3292 21.2539 10.8129C21.2539 8.68291 19.7922 6.89418 17.8172 6.39517L19.3825
                4.82981C21.6647 5.85556 23.2539 8.14869 23.2539 10.8129C23.2539 14.4338 20.3185 17.3692 16.6976
                17.3692H7.36831C7.3574 17.3692 7.34653 17.369 7.3357 17.3687C7.32465 17.369 7.31355 17.3692 7.30241
                17.3692C7.15304 17.3692 7.00484 17.3642 6.85797 17.3544L8.84316 15.3692ZM14.8594 5.11031L15.7025
                4.2672C15.2673 4.33099 14.9232 4.67511 14.8594 5.11031Z"
            />
            <path d="M19.801 2.28979L3.17187 18.919" stroke="currentColor" />
        </svg>
    );
}
